module.exports = __webpack_public_path__ + "static/img/trends1.118b3fb1.webp";